import React, { useState, useEffect, useRef } from "react";
import CreatedSuccessfully from "../../Assets/Images/CreatedSuccessfully.png";
import { Separator } from "Components/ui/separator";
import { Button } from "Components/ui/button";
import UseInnerWidth from "hooks/UseInnerWidth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";

function ChallengeCreatedSuccessfully() {
  const [isScrollable, setIsScrollable] = useState(false);
  const containerRef = useRef(null);
  const width = UseInnerWidth();

  useEffect(() => {
    const container = containerRef.current;
    if (container.scrollHeight > container.clientHeight) {
      setIsScrollable(true);
    } else {
      setIsScrollable(false);
    }
  }, [width]);

  const [searchParams, setSearchParams] = useSearchParams();
  //example on search params:
  // /createdSuccessfully?type=test&balance=10000&split=60&drawdown=4&id=123

  const navigate = useNavigate();

  console.log(searchParams.get("id"));
  return (
    <div
      ref={containerRef}
      className={`h-[100dvh] bg-background-secondary w-[100dvw] overflow-auto  hideScrollBar flex flex-col gap-4 items-center absolute top-0 left-0 z-[1000]  ${
        !isScrollable ? "justify-center" : ""
      }`}
    >
      <img
        src={CreatedSuccessfully}
        alt="created_success"
        className="w-[8rem] -mb-4"
      />
      <h1 className="text-5xl font-N_Medium">Challenge Activated</h1>
      <div className="text-center opacity-[0.6] text-base font-N_Roman -mt-2 mb-4">
        You’re all set! Your challenge has been created, and your trading
        journey begins
        <br /> now. Stay focused, trade smart, and aim for the top.
      </div>
      <div className="bg-black-dark border-none px-8 py-6 rounded-xl w-[30rem] flex flex-col gap-4">
        <div className="flex flex-row gap-4 justify-between items-center">
          <div className="text-base opacity-[0.3]">Challenge Type</div>
          <div className="text-base">{searchParams?.get("type")}</div>
        </div>
        <Separator className="bg-border-grey h-[0.1rem] opacity-[0.14]" />
        <div className="flex flex-row gap-4 justify-between items-center">
          <div className="text-base opacity-[0.3]">Starting Balance</div>
          <div className="text-base">
            {Number(searchParams?.get("balance"))?.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>
        <Separator className="bg-border-grey h-[0.1rem] opacity-[0.14]" />
        <div className="flex flex-row gap-4 justify-between items-center">
          <div className="text-base opacity-[0.3]">Account Login</div>
          <div className="text-base">{searchParams?.get("login")}</div>
        </div>
        <Separator className="bg-border-grey h-[0.1rem] opacity-[0.14]" />
        <div className="flex flex-row gap-4 justify-between items-center">
          <div className="text-base opacity-[0.3]">Daily Drawdown</div>
          <div className="text-base">
            {" "}
            {(Number(searchParams?.get("drawdown")) / 100)?.toLocaleString(
              "en-US",
              {
                style: "percent",
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
              }
            )}
          </div>
        </div>
      </div>
      <Button
        className="w-[15rem] py-4 mt-4"
        onClick={() => {
          searchParams.get("id")
            ? navigate("/challenge/" + searchParams.get("id") + "/Overview", {
                replace: true,
              })
            : toast.error("Invalid Challenge id!", {
                autoClose: 2000,
                className: "bg-red-opacity text-red",
              });
        }}
      >
        Start Trading
      </Button>
    </div>
  );
}

export default ChallengeCreatedSuccessfully;
